import { css } from 'styled-components';

const styles = css`
  .btn-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .product-tile-cont {
    padding: 0px 8px;
  }
  .product-title-wrapper {
    ${(props) => (props.fromBIADrawer ? `width: 222px;padding: 13px 0px;` : `width:100%;`)}
  }
  .product-image-container {
    display: flex;
    align-items: center;
    width: 101px;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  }
  .price-wrapper {
    min-height: 35px;
    margin-top: 4px;
  }
  .container-price {
    margin-top: 4px;
    font-size: 13px;
  }
  .bia-crd-img {
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .list-price {
    text-decoration: line-through;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }
  .product-brand-plp {
    color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
    font-size: 10px;
  }
  .ratings-container {
    position: relative;
    line-height: 15px;
  }
  .bia-card-image {
    height: auto;
    width: 100%;
  }
  .custom-rating img {
    width: 68px;
    height: 13px;
    min-width: 70px;
    line-height: 15px;
  }
  .custom-rating .reviews-count {
    font-size: 10px;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    margin-top: 1px;
  }
  .bia-atb {
    background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
    color: ${(props) => props.theme.colorPalette.white};
    font-size: 10px;
    padding: 8px 0;
    min-height: auto;
    letter-spacing: normal;
    border-radius: 6px;
    font-family: Nunito;
    font-weight: 800;
    margin-top: 2px;
  }
  .bia-atb:hover {
    border: none;
  }
  .bia-atb:focus {
    border: none;
  }
  .product-title-container {
    margin-top: 0;
    box-sizing: border-box;
    height: 57px !important;
    padding-top: 4px;
  }

  @media only screen and (min-width: 768px) {
    .bia-atb {
      background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
      color: ${(props) => props.theme.colorPalette.white};
      font-size: 10px;
      padding: 8px 0;
      min-height: auto;
      letter-spacing: normal;
      border-radius: 6px;
      border: none;
    }
    .bia-atb:hover {
      border: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .product-title-wrapper {
      ${(props) => (props.fromBIADrawer ? `width: 180px` : `width:100%`)}
    }
  }
  @media screen and (max-width: 350px) {
    .product-title-wrapper {
      ${(props) => (props.fromBIADrawer ? `width: 170px` : `width:100%`)}
    }
  }
`;

export default styles;
